export default "__VITE_ASSET__ClNO185Y__"